import React from "react";

const HintContext = React.createContext({});

export default HintContext;